import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CTASection = () => {
  const navigate = useNavigate();

  const benefits = [
    { icon: 'CheckCircle2', text: 'No upfront costs or hidden fees' },
    { icon: 'CheckCircle2', text: 'Access to premium brand campaigns' },
    { icon: 'CheckCircle2', text: 'Real-time performance tracking' },
    { icon: 'CheckCircle2', text: '24/7 dedicated support team' }
  ];

  return (
  <section className="py-24 sm:py-32 lg:py-40 bg-gradient-to-b from-black via-gray-900 to-black relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-primary/20 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-red-600/20 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-gradient-to-r from-primary/5 via-transparent to-red-600/5"></div>
      </div>
      
      {/* Decorative floating elements */}
      <div className="absolute top-20 right-10 w-20 h-20 border-2 border-primary/20 rounded-full animate-float"></div>
      <div className="absolute bottom-20 left-10 w-16 h-16 bg-primary/10 rounded-lg rotate-45 animate-float-delayed"></div>
      
  <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
  <div className="text-center mb-20">
          <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-gradient-to-r from-primary/20 to-red-600/20 backdrop-blur-sm rounded-full mb-8 border border-primary/30 shadow-lg animate-pulse">
            <Icon name="Star" size={24} className="text-primary" />
            <span className="text-sm font-semibold text-white uppercase tracking-wide">Join the Revolution</span>
          </div>

          <h2 className="text-5xl sm:text-6xl lg:text-7xl font-black text-white mb-8 tracking-tight leading-tight drop-shadow-2xl">
            Start Earning with
            <span className="block mt-4 bg-gradient-to-r from-primary via-red-400 to-orange-500 bg-clip-text text-transparent">
              Performance-Based Rewards
            </span>
          </h2>

          <p className="text-xl text-white/90 max-w-3xl mx-auto mb-14 leading-relaxed font-medium">
            Join <span className="text-primary font-bold">NOONX</span> today and transform your content into a sustainable income stream. Get paid for every view you deliver.
          </p>

          {/* Benefits grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl mx-auto mb-14">
            {benefits?.map((benefit, index) => (
              <div
                key={index}
                className="flex items-center gap-3 bg-white/5 backdrop-blur-sm rounded-xl p-5 border border-white/10 hover:border-primary/30 hover:bg-white/10 transition-all duration-300 group"
              >
                <div className="bg-gradient-to-br from-primary to-red-600 rounded-lg p-2 group-hover:scale-110 transition-transform duration-300">
                  <Icon name={benefit?.icon} size={20} className="text-white flex-shrink-0" />
                </div>
                <span className="text-white text-left font-medium text-base">{benefit?.text}</span>
              </div>
            ))}
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mt-10">
            <Button
              variant="default"
              size="lg"
              onClick={() => navigate('/authentication', { state: { role: 'creator' } })}
              className="group relative bg-white text-primary font-bold px-12 py-6 rounded-2xl shadow-2xl transition-all duration-300 hover:shadow-primary/50 hover:scale-105 text-lg overflow-hidden"
            >
              <span className="relative flex items-center gap-3 z-10">
                <Icon name="Rocket" size={24} />
                Start as Creator
              </span>
              <div className="absolute inset-0 bg-gradient-to-r from-primary to-red-600 translate-y-full group-hover:translate-y-0 transition-transform duration-300"></div>
              <span className="absolute inset-0 flex items-center justify-center gap-3 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300 font-bold">
                <Icon name="Rocket" size={24} />
                Start as Creator
              </span>
            </Button>
            <Button
              variant="outline"
              size="lg"
              onClick={() => navigate('/authentication', { state: { role: 'brand' } })}
              className="border-2 border-primary/40 text-white hover:bg-gradient-to-r hover:from-primary hover:to-red-600 hover:border-transparent backdrop-blur-sm text-lg px-12 py-6 rounded-2xl font-bold transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-primary/30"
            >
              <Icon name="Building2" size={24} className="mr-2" />
              Join as Brand
            </Button>
          </div>

          {/* Trust indicators */}
          <div className="mt-20 pt-16 border-t border-primary/10">
            <p className="text-white/60 text-base mb-10 uppercase tracking-wider font-bold">Trusted by Industry Leaders</p>
            <div className="flex flex-wrap items-center justify-center gap-12 sm:gap-16">
              {[1, 2, 3, 4, 5]?.map((i) => (
                <div key={i} className="w-32 h-16 bg-white/5 backdrop-blur-sm rounded-xl flex items-center justify-center border border-white/10 hover:border-primary/30 transition-all duration-300 hover:scale-110 shadow-lg group">
                  <Icon name="Building2" size={36} className="text-white/30 group-hover:text-primary transition-colors duration-300" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;